import {Injectable} from '@angular/core';
import {HttpClient } from '@angular/common/http';
import {environment} from '../shared/environments/environment';
import {concatMap, EMPTY, expand, map, Observable, toArray} from 'rxjs';
import {Params} from '@angular/router';
import {IPaginatedResponse} from '../typing/response.interface';
import {ICustomerUpdate, IPerson, IPersonCreate, IPersonUpdate, IPersonUpdateResponse} from '../typing/person.interface';
import {Person} from '../classes/person.class';
import { PersonStatusEnum } from '../enums/status.enum';

@Injectable({
    providedIn: 'root'
})
export class PersonService {

    constructor(private http: HttpClient) {
    }

    // получение всех людей
    getAllPersons(query: Params): Observable<Person[]> {
        return this.getWorkersPage(query, 1).pipe(
            expand(response =>
                response.links.next ? this.getWorkersPage(query, response.meta.currentPage + 1) : EMPTY
            ),
            concatMap(response => response.data),
            toArray()
        );
    }

    // постраничное получение людей
    private getWorkersPage(query: Params, page: number): Observable<IPaginatedResponse<Person>> {
        const params = { ...query, page, limit: 100 };

        return this.http.get<IPaginatedResponse<IPerson>>(`${environment.API_BASE_PATH}/persons`, { params }).pipe(
            map(response => ({
                ...response,
                data: response.data.map(person => new Person(person))
            }))
        );
    }

    getList(query: Params = {}): Observable<IPaginatedResponse<IPerson>> {
        return this.http.get<IPaginatedResponse<IPerson>>(`${environment.API_BASE_PATH}/persons`, {params: query});
    }

    getPerson(id: number): Observable<IPerson> {
        return this.http.get<IPerson>(`${environment.API_BASE_PATH}/person/${id}`);
    }

    create(person: IPersonCreate): Observable<IPerson> {
        return this.http.post<IPerson>(`${environment.API_BASE_PATH}/person`, person);
    }

    update(person: IPersonUpdate): Observable<IPersonUpdateResponse> {
        return this.http.put<IPersonUpdateResponse>(`${environment.API_BASE_PATH}/person/${person.id}`, person);
    }

    updateGeolocation(person: IPersonUpdate): Observable<IPerson> {
        return this.http.put<IPerson>(`${environment.API_BASE_PATH}/geo/${person.id}`, person);
    }

    deletePersons(data: number[]): Observable<void> {
        return this.http.delete<void>(`${environment.API_BASE_PATH}/persons`, {
            body: data
        });
    }

    currentUser(): Observable<Person> {
        return this.http.get<IPerson>(`${environment.API_BASE_PATH}/user/current`).pipe(map(user => new Person(user)));
    }

    updateCustomer(person: ICustomerUpdate): Observable<ICustomerUpdate> {
        return this.http.put<ICustomerUpdate>(`${environment.API_BASE_PATH}/customer/${person.id}`, person);
    }

    registerStatus(executorId: number, date: Date, status: PersonStatusEnum): Observable<void> {
        return this.http.post<void>(`${environment.API_BASE_PATH}/executor-status`, {executorId, date, status});
    }
}
